import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EPeriodsActionTypes, TGetPeriodsFailed } from './types';

export const getPeriodsFailed: () => TGetPeriodsFailed = actionGenerator<EPeriodsActionTypes.Failed>(
  EPeriodsActionTypes.Failed,
);
